import React from 'react';
import { reset } from 'redux-form';
import format from 'string-template';
import { connect } from 'react-redux';
import { length } from 'redux-form-validators';
import { toPlainObject, isEmpty } from 'lodash';

import {
    FIRSTNAME_LENGTH,
    NAME_LENGTH,
    ADDRESS_LENGTH,
    POSTCODE_LENGTH,
    CITY_LENGTH,
    COUNTRY_LENGTH,
    PHONE_LENGTH
} from '../../../../constants/form';
import {
    FormComponent,
    TextInputFieldComponent,
    SelectFieldComponent,
    PhoneInputFieldComponent,
    LegendFieldComponent,
    IBANInputFieldComponent,
    BICInputFieldComponent
} from '../../../../components/form';
import { MONSIEUR, MADAME } from '../../../../constants/civilities';
import { sendPaymentRequest } from '../../../../services/account/paymentrequest/request/actions';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

const FORM_NAME = 'paymentrequest-form';

class PaymentRequestFormComponent extends React.Component {
    componentDidMount() {
        this.scrollTop();
    }

    scrollTop = () => {
        if (document.getElementById('paymentAreaAnchor')) {
            document.getElementById('paymentAreaAnchor').scrollIntoView({ behavior: 'smooth' });
        }
    };

    submit = formData => {
        const { sendPaymentRequest, reset } = this.props;

        sendPaymentRequest(formData, () => {
            reset(FORM_NAME);
            this.scrollTop();
        });
    };

    validate = values => {
        const { i18nCommon } = this.props;
        const errors = {};

        if (!values.civility) {
            errors.civility = i18nCommon.OPTION_REQUIRED;
        }

        return errors;
    };

    render() {
        const {
            i18n,
            requestSubmit,
            errorSubmit,
            errorMessage,
            COUNTRIES,
            CIVILITIES,
            initialValues,
            i18nCommon
        } = this.props;

        return (
            <FormComponent
                form={FORM_NAME}
                initialValues={initialValues}
                validate={this.validate}
                classNameInputContainer="grid-2 has-gutter"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                submitText={i18n.PAYMENT_REQUEST_FORM.PAYMENT_REQUEST_BUTTON}>
                <SelectFieldComponent
                    name="country"
                    label={i18nCommon.IBAN_CODE_IBAN}
                    defaultOptionLabel={COUNTRIES.PAYS_BAS}
                    isRequired
                    options={[]}
                    classNameInputContainer="mr50"
                />

                <IBANInputFieldComponent name="iban" placeholder={i18nCommon.IBAN_CODE_DETAIL} />
                <LegendFieldComponent classNameInputContainer="format-iban-container">
                    <div className="format-iban">{i18nCommon.IBAN_FORMAT}</div>
                </LegendFieldComponent>

                <BICInputFieldComponent
                    name="bic"
                    placeholder={i18nCommon.CODE_BIC_DETAIL}
                    label={i18nCommon.CODE_BIC}
                    isRequired
                    classNameInputContainer="mr50"
                />
                <SelectFieldComponent
                    name="civility"
                    label={i18nCommon.LABEL_CIVILITY}
                    isRequired
                    defaultOptionLabel="--"
                    classNameInputContainer="mr50"
                    options={[
                        { label: CIVILITIES.MONSIEUR, value: MONSIEUR },
                        { label: CIVILITIES.MADAME, value: MADAME }
                    ]}
                />
                <TextInputFieldComponent
                    name="lastname"
                    placeholder={i18nCommon.LABEL_LASTNAME}
                    label={i18nCommon.LABEL_LASTNAME}
                    isRequired
                    validate={[
                        length({
                            max: NAME_LENGTH,
                            msg: format(
                                i18nCommon.TEXT_TOOLONG,
                                NAME_LENGTH,
                                NAME_LENGTH > 1 ? 's' : ''
                            )
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="firstname"
                    placeholder={i18nCommon.LABEL_FIRSTNAME}
                    label={i18nCommon.LABEL_FIRSTNAME}
                    isRequired
                    validate={[
                        length({
                            max: FIRSTNAME_LENGTH,
                            msg: format(
                                i18nCommon.TEXT_TOOLONG,
                                FIRSTNAME_LENGTH,
                                FIRSTNAME_LENGTH > 1 ? 's' : ''
                            )
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="address"
                    classNameInputContainer="one-half"
                    placeholder={i18nCommon.LABEL_ADDRESS}
                    label={i18nCommon.LABEL_ADDRESS}
                    isRequired
                    validate={[
                        length({
                            max: ADDRESS_LENGTH,
                            msg: format(i18nCommon.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="zipcode"
                    classNameInputContainer="one-quarter"
                    placeholder={i18nCommon.LABEL_ZIPCODE}
                    label={i18nCommon.LABEL_ZIPCODE}
                    maxLength={POSTCODE_LENGTH}
                    isRequired
                    validate={[
                        length({
                            max: POSTCODE_LENGTH,
                            msg: format(i18nCommon.ZIP_CODE_SIZE_ERROR, POSTCODE_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="city"
                    classNameInputContainer="one-quarter"
                    placeholder={i18nCommon.LABEL_CITY}
                    label={i18nCommon.LABEL_CITY}
                    isRequired
                    validate={[
                        length({
                            max: CITY_LENGTH,
                            msg: format(i18nCommon.CITY_SIZE_ERROR, CITY_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="country"
                    label={i18nCommon.LABEL_COUNTRY}
                    placeholder={i18nCommon.LABEL_COUNTRY}
                    classNameInputContainer="one-half"
                    validate={[
                        length({
                            max: COUNTRY_LENGTH,
                            msg: format(i18nCommon.COUNTRY_SIZE_ERROR, COUNTRY_LENGTH)
                        })
                    ]}
                />
                <PhoneInputFieldComponent
                    name="phoneNumber"
                    label={i18nCommon.LABEL_PHONENUMBER}
                    classNameInputContainer="one-half"
                    validate={[
                        length({
                            max: PHONE_LENGTH,
                            msg: format(i18nCommon.PHONENUMBER_SIZE_ERROR, PHONE_LENGTH)
                        })
                    ]}
                />
                <LegendFieldComponent classNameInputContainer="full">
                    {i18nCommon.MANDATORY_FIELD}
                </LegendFieldComponent>
                <LegendFieldComponent classNameInputContainer="full">
                    {i18n.PAYMENT_REQUEST_FORM.IBAN_DATA_COLLECTED}
                </LegendFieldComponent>
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
            </FormComponent>
        );
    }
}

const mapDispatchToProps = {
    sendPaymentRequest,
    reset
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);
    const isAuthed = !isEmpty(state.authentication.token);

    return {
        user: user,
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        successSubmit: paymentRequestSelector.isSuccess(state),
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        CIVILITIES: state.i18n.feature.form.CIVILITIES,
        COUNTRIES: state.i18n.feature.form.COUNTRIES,
        i18nCommon: state.i18n.feature.form,
        initialValues: isAuthed
            ? {
                  civility: user.civility ? user.civility : null,
                  lastname: user.lastname ? user.lastname : '',
                  firstname: user.firstname ? user.firstname : '',
                  address: user.address ? user.address : '',
                  zipcode: user.postcode ? user.postcode : '',
                  city: user.city ? user.city : '',
                  country: user.country ? user.country : '',
                  iban: ''
              }
            : {}
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRequestFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestFormComponent.js